export const DMPTOOL_NAME = 'DMP Tool';
export const DMPTOOL_URL = 'https://dmptool.org/';
